<template>
	<vs-input v-model="demand" class="w-full" ref="inputDemand" @keydown="onKeyDown($event)" />
</template>

<script>
export default {
	data() {
		return {
			demand: "",
			cancelBeforeStart: true,
			KEY_BACKSPACE: "Backspace",
			KEY_ENTER: "Enter",
			KEY_TAB: "Tab",
		};
	},
	created() {
		this.setInitialState(this.params);
		this.cancelBeforeStart = this.params.charPress && "1234567890".indexOf(this.params.charPress) < 0;
	},
	computed: {
		textColor() {
			return this.params.value ? "text-primary" : "text-grey";
		},
	},
	methods: {
		getValue() {
			return this.demand;
		},

		isCancelBeforeStart() {
			return this.cancelBeforeStart;
		},

		setInitialState(params) {
			let startValue;

			if (params.eventKey === this.KEY_BACKSPACE) {
				// if backspace or delete pressed, we clear the cell
				startValue = "";
			} else if (params.charPress) {
				// if a letter was pressed, we start with the letter
				startValue = params.charPress;
			} else {
				// otherwise we start with the current value
				startValue = params.value;
			}
			this.demand = startValue;
		},

		// will reject the number if it greater than 1,000,000
		// not very practical, but demonstrates the method.
		isCancelAfterEnd() {
			return this.demand > 1000000;
		},

		onKeyDown(event) {
			if (event.key === "Escape") {
				return;
			}
			if (this.isLeftOrRight(event) || this.isBackspace(event)) {
				event.stopPropagation();
				return;
			}

			if (!this.finishedEditingPressed(event) && !this.isKeyPressedNumeric(event)) {
				if (event.preventDefault) event.preventDefault();
			}
		},

		isCharNumeric(charStr) {
			return /\d/.test(charStr);
		},

		isKeyPressedNumeric(event) {
			const charStr = event.key;
			return this.isCharNumeric(charStr);
		},

		finishedEditingPressed(event) {
			const key = event.key;
			return key === this.KEY_ENTER || key === this.KEY_TAB;
		},

		isBackspace(event) {
			return event.key === this.KEY_BACKSPACE;
		},

		isLeftOrRight(event) {
			return ["ArrowLeft", "ArrowRight"].indexOf(event.key) > -1;
		},
	},
};
</script>
